import { render } from "./IndexProgramme.vue?vue&type=template&id=2980cfb9"
import script from "./IndexProgramme.vue?vue&type=script&lang=js"
export * from "./IndexProgramme.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__